import Vue from 'vue';
import VueP5 from 'vue-p5';

Vue.component('vue-p5', VueP5);